const imgLoader = (name: string, ext: string) => {
  return new URL(`../assets/${name}.${ext}`, import.meta.url).href
}

export default imgLoader
